// Auto-generated (azurerm keys) from 86 Azure resources
export const azureTop100Meta: Record<
  string,
  { displayName: string; category: string; armType: string; bicepType: string }
> = {
  azurerm_batch_account: {
    displayName: "Batch Accounts",
    category: "compute",
    armType: "Microsoft.Batch/batchAccounts",
    bicepType: "Microsoft.Batch/batchAccounts",
  },
  azurerm_app_service_certificate: {
    displayName: "App Service Certificates",
    category: "compute",
    armType: "Microsoft.Web/certificates",
    bicepType: "Microsoft.Web/certificates",
  },
  azurerm_app_service_environment: {
    displayName: "App Service Environments",
    category: "compute",
    armType: "Microsoft.Web/hostingEnvironments",
    bicepType: "Microsoft.Web/hostingEnvironments",
  },
  azurerm_app_service_plan: {
    displayName: "App Service Plans",
    category: "compute",
    armType: "Microsoft.Web/serverfarms",
    bicepType: "Microsoft.Web/serverfarms",
  },
  azurerm_kubernetes_cluster: {
    displayName: "Azure Kubernetes Services (AKS)",
    category: "compute",
    armType: "Microsoft.ContainerService/managedClusters",
    bicepType: "Microsoft.ContainerService/managedClusters",
  },
  azurerm_logic_app_standard: {
    displayName: "Logic App Standard",
    category: "compute",
    armType: "Microsoft.Web/sites",
    bicepType: "Microsoft.Web/sites",
  },
  azurerm_container_app: {
    displayName: "Container Apps",
    category: "compute",
    armType: "Microsoft.App/containerApps",
    bicepType: "Microsoft.App/containerApps",
  },
  azurerm_logic_app_workflow: {
    displayName: "Azure Logic Apps",
    category: "compute",
    armType: "Microsoft.Logic/workflows",
    bicepType: "Microsoft.Logic/workflows",
  },
  azurerm_function_app: {
    displayName: "Azure Functions",
    category: "compute",
    armType: "Microsoft.Web/sites",
    bicepType: "Microsoft.Web/sites",
  },
  azurerm_container_registry: {
    displayName: "Azure Container Registry",
    category: "compute",
    armType: "Microsoft.ContainerRegistry/registries",
    bicepType: "Microsoft.ContainerRegistry/registries",
  },
  azurerm_orchestrated_virtual_machine_scale_set: {
    displayName: "Azure Virtual Machine Scale Sets",
    category: "compute",
    armType: "Microsoft.Compute/virtualMachineScaleSets",
    bicepType: "Microsoft.Compute/virtualMachineScaleSets",
  },
  azurerm_linux_virtual_machine: {
    displayName: "Azure Virtual Machines (Linux)",
    category: "compute",
    armType: "Microsoft.Compute/virtualMachines",
    bicepType: "Microsoft.Compute/virtualMachines",
  },
  azurerm_virtual_machine: {
    displayName: "Azure Virtual Machines (Legacy)",
    category: "compute",
    armType: "Microsoft.Compute/virtualMachines",
    bicepType: "Microsoft.Compute/virtualMachines",
  },
  azurerm_windows_virtual_machine: {
    displayName: "Azure Virtual Machines (Windows)",
    category: "compute",
    armType: "Microsoft.Compute/virtualMachines",
    bicepType: "Microsoft.Compute/virtualMachines",
  },
  azurerm_container_group: {
    displayName: "Azure Container Instances",
    category: "compute",
    armType: "Microsoft.ContainerInstance/containerGroups",
    bicepType: "Microsoft.ContainerInstance/containerGroups",
  },
  azurerm_databricks_workspace: {
    displayName: "Azure Databricks",
    category: "compute",
    armType: "Microsoft.Databricks/workspaces",
    bicepType: "Microsoft.Databricks/workspaces",
  },
  azurerm_storage_blob: {
    displayName: "Storage Blobs",
    category: "data",
    armType: "",
    bicepType: "",
  },
  azurerm_mssql_database: {
    displayName: "Azure SQL Databases",
    category: "data",
    armType: "Microsoft.Sql/servers/databases",
    bicepType: "Microsoft.Sql/servers/databases",
  },
  azurerm_mssql_server: {
    displayName: "Azure SQL Servers",
    category: "data",
    armType: "Microsoft.Sql/servers",
    bicepType: "Microsoft.Sql/servers",
  },
  azurerm_recovery_services_vault: {
    displayName: "Azure Recovery Services Vaults",
    category: "data",
    armType: "Microsoft.RecoveryServices/vaults",
    bicepType: "Microsoft.RecoveryServices/vaults",
  },
  azurerm_mssql_managed_instance: {
    displayName: "Azure Managed SQL Instances",
    category: "data",
    armType: "Microsoft.Sql/managedInstances",
    bicepType: "Microsoft.Sql/managedInstances",
  },
  azurerm_kusto_cluster: {
    displayName: "Azure Data Explorer Clusters",
    category: "data",
    armType: "Microsoft.Kusto/clusters",
    bicepType: "Microsoft.Kusto/clusters",
  },
  
  azurerm_mysql_server: {
    displayName: "Azure Database for MySQL servers",
    category: "data",
    armType: "Microsoft.DBforMySQL/servers",
    bicepType: "Microsoft.DBforMySQL/servers",
  },
  azurerm_mariadb_server: {
    displayName: "Azure Database for MariaDB servers",
    category: "data",
    armType: "Microsoft.DBforMariaDB/servers",
    bicepType: "Microsoft.DBforMariaDB/servers",
  },
  azurerm_storage_account: {
    displayName: "Azure Storage Accounts",
    category: "data",
    armType: "Microsoft.Storage/storageAccounts",
    bicepType: "Microsoft.Storage/storageAccounts",
  },
  azurerm_stream_analytics_job: {
    displayName: "Azure Stream Analytics Jobs",
    category: "data",
    armType: "Microsoft.StreamAnalytics/streamingjobs",
    bicepType: "Microsoft.StreamAnalytics/streamingjobs",
  },
  azurerm_synapse_workspace: {
    displayName: "Azure Synapse Analytics",
    category: "data",
    armType: "Microsoft.Synapse/workspaces",
    bicepType: "Microsoft.Synapse/workspaces",
  },
  azurerm_synapse_sql_pool: {
    displayName: "Synapse SQL Pool",
    category: "data",
    armType: "Microsoft.Synapse/workspaces/sqlPools",
    bicepType: "Microsoft.Synapse/workspaces/sqlPools",
  },
  azurerm_synapse_spark_pool: {
    displayName: "Synapse Spark Pool",
    category: "data",
    armType: "Microsoft.Synapse/workspaces/bigDataPools",
    bicepType: "Microsoft.Synapse/workspaces/bigDataPools",
  },
 
  azurerm_data_lake_analytics_account: {
    displayName: "Data Lake Analytics",
    category: "data",
    armType: "Microsoft.DataLakeAnalytics/accounts",
    bicepType: "Microsoft.DataLakeAnalytics/accounts",
  },
  azurerm_data_lake_store_account: {
    displayName: "Data Lake Store Accounts",
    category: "data",
    armType: "Microsoft.DataLakeStore/accounts",
    bicepType: "Microsoft.DataLakeStore/accounts",
  },
  azurerm_postgresql_server: {
    displayName: "Azure Database for PostgreSQL servers",
    category: "data",
    armType: "Microsoft.DBforPostgreSQL/servers",
    bicepType: "Microsoft.DBforPostgreSQL/servers",
  },
  azurerm_service_fabric_mesh_application: {
    displayName: "Azure Service Fabric Mesh",
    category: "general",
    armType: "Microsoft.ServiceFabricMesh/applications",
    bicepType: "Microsoft.ServiceFabricMesh/applications",
  },
  azurerm_service_fabric_cluster: {
    displayName: "Azure Service Fabric Clusters",
    category: "general",
    armType: "Microsoft.ServiceFabric/clusters",
    bicepType: "Microsoft.ServiceFabric/clusters",
  },
  azurerm_cdn_profile: {
    displayName: "CDN Profiles",
    category: "general",
    armType: "Microsoft.Cdn/profiles",
    bicepType: "Microsoft.Cdn/profiles",
  },
  azurerm_resource_group: {
    displayName: "Resource Group",
    category: "containers",
    armType: "Microsoft.Resources/resourceGroups",
    bicepType: "Microsoft.Resources/resourceGroups",
  },
  azurerm_cognitive_account: {
    displayName: "Cognitive Services",
    category: "general",
    armType: "Microsoft.CognitiveServices/accounts",
    bicepType: "Microsoft.CognitiveServices/accounts",
  },
  azurerm_user_assigned_identity: {
    displayName: "Azure Managed Identities",
    category: "general",
    armType: "Microsoft.ManagedIdentity/userAssignedIdentities",
    bicepType: "Microsoft.ManagedIdentity/userAssignedIdentities",
  },
  azurerm_api_management: {
    displayName: "API Management Services",
    category: "general",
    armType: "Microsoft.ApiManagement/service",
    bicepType: "Microsoft.ApiManagement/service",
  },
  azurerm_machine_learning_workspace: {
    displayName: "Azure Machine Learning Workspaces",
    category: "general",
    armType: "Microsoft.MachineLearningServices/workspaces",
    bicepType: "Microsoft.MachineLearningServices/workspaces",
  },
  azurerm_data_factory: {
    displayName: "Azure Data Factory",
    category: "general",
    armType: "Microsoft.DataFactory/factories",
    bicepType: "Microsoft.DataFactory/factories",
  },
  azurerm_managed_disk: {
    displayName: "Azure Managed Disks",
    category: "general",
    armType: "Microsoft.Compute/disks",
    bicepType: "Microsoft.Compute/disks",
  },
  azurerm_firewall: {
    displayName: "Azure Firewall",
    category: "general",
    armType: "Microsoft.Network/azureFirewalls",
    bicepType: "Microsoft.Network/azureFirewalls",
  },
  azurerm_redis_cache: {
    displayName: "Azure Cache for Redis",
    category: "general",
    armType: "Microsoft.Cache/Redis",
    bicepType: "Microsoft.Cache/Redis",
  },
  azurerm_automation_account: {
    displayName: "Automation Accounts",
    category: "general",
    armType: "Microsoft.Automation/automationAccounts",
    bicepType: "Microsoft.Automation/automationAccounts",
  },
  azurerm_availability_set: {
    displayName: "Availability Sets",
    category: "general",
    armType: "Microsoft.Compute/availabilitySets",
    bicepType: "Microsoft.Compute/availabilitySets",
  },
  azurerm_app_configuration: {
    displayName: "App Configuration Stores",
    category: "general",
    armType: "Microsoft.AppConfiguration/configurationStores",
    bicepType: "Microsoft.AppConfiguration/configurationStores",
  },
  azurerm_bot_service: {
    displayName: "Azure Bot Services",
    category: "general",
    armType: "Microsoft.BotService/botServices",
    bicepType: "Microsoft.BotService/botServices",
  },
  azurerm_eventgrid_domain: {
    displayName: "Event Grid Domains",
    category: "integration",
    armType: "Microsoft.EventGrid/domains",
    bicepType: "Microsoft.EventGrid/domains",
  },
  
  azurerm_servicebus_namespace: {
    displayName: "Azure Service Bus",
    category: "integration",
    armType: "Microsoft.ServiceBus/namespaces",
    bicepType: "Microsoft.ServiceBus/namespaces",
  },
  azurerm_eventgrid_topic: {
    displayName: "Event Grid Topics",
    category: "integration",
    armType: "Microsoft.EventGrid/topics",
    bicepType: "Microsoft.EventGrid/topics",
  },
  azurerm_signalr_service: {
    displayName: "Azure SignalR Service",
    category: "integration",
    armType: "Microsoft.SignalRService/signalR",
    bicepType: "Microsoft.SignalRService/signalR",
  },
  azurerm_site_recovery_fabric: {
    displayName: "Azure Site Recovery",
    category: "integration",
    armType: "Microsoft.RecoveryServices/vaults/replicationFabrics",
    bicepType: "Microsoft.RecoveryServices/vaults/replicationFabrics",
  },
  azurerm_media_services_account: {
    displayName: "Azure Media Services",
    category: "integration",
    armType: "Microsoft.Media/mediaservices",
    bicepType: "Microsoft.Media/mediaservices",
  },
  azurerm_eventhub_namespace: {
    displayName: "Event Hubs",
    category: "integration",
    armType: "Microsoft.EventHub/namespaces",
    bicepType: "Microsoft.EventHub/namespaces",
  },
  azurerm_iothub: {
    displayName: "Azure IoT Hubs",
    category: "iot-edge",
    armType: "Microsoft.Devices/IotHubs",
    bicepType: "Microsoft.Devices/IotHubs",
  },
  azurerm_iotcentral_application: {
    displayName: "Azure IoT Central Applications",
    category: "iot-edge",
    armType: "Microsoft.IoTCentral/iotApps",
    bicepType: "Microsoft.IoTCentral/iotApps",
  },
  azurerm_arc_machine: {
    displayName: "Azure Arc Servers",
    category: "iot-edge",
    armType: "Microsoft.HybridCompute/machines",
    bicepType: "Microsoft.HybridCompute/machines",
  },
  azurerm_search_service: {
    displayName: "Azure Cognitive Search",
    category: "iot-edge",
    armType: "Microsoft.Search/searchServices",
    bicepType: "Microsoft.Search/searchServices",
  },
  azurerm_application_insights: {
    displayName: "Application Insights",
    category: "monitoring",
    armType: "Microsoft.Insights/components",
    bicepType: "Microsoft.Insights/components",
  },
  azurerm_monitor_action_group: {
    displayName: "Azure Monitor",
    category: "monitoring",
    armType: "Microsoft.Insights/actionGroups",
    bicepType: "Microsoft.Insights/actionGroups",
  },
  azurerm_bastion_host: {
    displayName: "Azure Bastion",
    category: "networking",
    armType: "Microsoft.Network/bastionHosts",
    bicepType: "Microsoft.Network/bastionHosts",
  },
  azurerm_frontdoor: {
    displayName: "Front Door (Classic)",
    category: "networking",
    armType: "Microsoft.Network/frontDoors",
    bicepType: "Microsoft.Network/frontDoors",
  },
  azurerm_express_route_circuit: {
    displayName: "ExpressRoute Circuits",
    category: "networking",
    armType: "Microsoft.Network/expressRouteCircuits",
    bicepType: "Microsoft.Network/expressRouteCircuits",
  },
  azurerm_lb: {
    displayName: "Azure Load Balancers",
    category: "networking",
    armType: "Microsoft.Network/loadBalancers",
    bicepType: "Microsoft.Network/loadBalancers",
  },
  azurerm_network_interface: {
    displayName: "Azure Network Interfaces",
    category: "networking",
    armType: "Microsoft.Network/networkInterfaces",
    bicepType: "Microsoft.Network/networkInterfaces",
  },
  azurerm_network_security_group: {
    displayName: "Azure Network Security Groups",
    category: "networking",
    armType: "Microsoft.Network/networkSecurityGroups",
    bicepType: "Microsoft.Network/networkSecurityGroups",
  },
  azurerm_dns_zone: {
    displayName: "Azure DNS Zones",
    category: "networking",
    armType: "Microsoft.Network/dnsZones",
    bicepType: "Microsoft.Network/dnsZones",
  },
  azurerm_application_gateway: {
    displayName: "Application Gateways",
    category: "networking",
    armType: "Microsoft.Network/applicationGateways",
    bicepType: "Microsoft.Network/applicationGateways",
  },
  azurerm_private_endpoint: {
    displayName: "Azure Private Endpoints",
    category: "networking",
    armType: "Microsoft.Network/privateEndpoints",
    bicepType: "Microsoft.Network/privateEndpoints",
  },
  azurerm_traffic_manager_profile: {
    displayName: "Azure Traffic Manager Profiles",
    category: "networking",
    armType: "Microsoft.Network/trafficManagerProfiles",
    bicepType: "Microsoft.Network/trafficManagerProfiles",
  },
  azurerm_public_ip: {
    displayName: "Azure Public IP Addresses",
    category: "networking",
    armType: "Microsoft.Network/publicIPAddresses",
    bicepType: "Microsoft.Network/publicIPAddresses",
  },
  
  azurerm_virtual_network: {
    displayName: "Azure Virtual Networks",
    category: "networking",
    armType: "Microsoft.Network/virtualNetworks",
    bicepType: "Microsoft.Network/virtualNetworks",
  },
  azurerm_subnet: {
    displayName: "Azure Subnets",
    category: "networking",
    armType: "Microsoft.Network/virtualNetworks/subnets",
    bicepType: "Microsoft.Network/virtualNetworks/subnets",
  },
  azurerm_cdn_frontdoor_profile: {
    displayName: "Azure Front Door",
    category: "networking",
    armType: "Microsoft.Cdn/profiles",
    bicepType: "Microsoft.Cdn/profiles",
  },
  azurerm_cdn_endpoint: {
    displayName: "Content Delivery Network (CDN) Endpoints",
    category: "networking",
    armType: "Microsoft.Cdn/profiles/endpoints",
    bicepType: "Microsoft.Cdn/profiles/endpoints",
  },
  azurerm_role_assignment: {
    displayName: "Azure Role Assignments",
    category: "security",
    armType: "Microsoft.Authorization/roleAssignments",
    bicepType: "Microsoft.Authorization/roleAssignments",
  },
  azurerm_active_directory_domain_service: {
    displayName: "Azure Active Directory Domain Services",
    category: "security",
    armType: "Microsoft.AAD/DomainServices",
    bicepType: "Microsoft.AAD/DomainServices",
  },
  azurerm_sentinel_log_analytics_workspace_onboarding: {
    displayName: "Azure Sentinel",
    category: "security",
    armType: "Microsoft.SecurityInsights/onboardingStates",
    bicepType: "Microsoft.SecurityInsights/onboardingStates",
  },
  azurerm_key_vault: {
    displayName: "Azure Key Vaults",
    category: "security",
    armType: "Microsoft.KeyVault/vaults",
    bicepType: "Microsoft.KeyVault/vaults",
  },

  azurerm_policy_assignment: {
    displayName: "Azure Policy Assignments",
    category: "security",
    armType: "Microsoft.Authorization/policyAssignments",
    bicepType: "Microsoft.Authorization/policyAssignments",
  },
  azurerm_cosmosdb_account: {
    displayName: "Cosmos DB Accounts",
    category: "databases",
    armType: "Microsoft.DocumentDB/databaseAccounts",
    bicepType: "Microsoft.DocumentDB/databaseAccounts",
  },
  azurerm_cosmosdb_sql_database: {
    displayName: "Cosmos DB SQL Databases",
    category: "databases",
    armType: "Microsoft.DocumentDB/databaseAccounts/sqlDatabases",
    bicepType: "Microsoft.DocumentDB/databaseAccounts/sqlDatabases",
  },
  azurerm_eventgrid_event_subscription: {
    displayName: "Event Grid Event Subscriptions",
    category: "integration",
    armType: "Microsoft.EventGrid/eventSubscriptions",
    bicepType: "Microsoft.EventGrid/eventSubscriptions",
  },
  azurerm_key_vault_certificate: {
    displayName: "Key Vault Certificates",
    category: "security",
    armType: "Microsoft.KeyVault/vaults/certificates",
    bicepType: "Microsoft.KeyVault/vaults/certificates",
  },
  azurerm_key_vault_key: {
    displayName: "Key Vault Keys",
    category: "security",
    armType: "Microsoft.KeyVault/vaults/keys",
    bicepType: "Microsoft.KeyVault/vaults/keys",
  },
  azurerm_key_vault_secret: {
    displayName: "Key Vault Secrets",
    category: "security",
    armType: "Microsoft.KeyVault/vaults/secrets",
    bicepType: "Microsoft.KeyVault/vaults/secrets",
  },
  azurerm_vpn_gateway: {
    displayName: "VPN Gateways",
    category: "networking",
    armType: "Microsoft.Network/vpnGateways",
    bicepType: "Microsoft.Network/vpnGateways",
  },
};
export const top100Meta = azureTop100Meta;
export default azureTop100Meta;
